import React from 'react';
import { shape } from 'prop-types';
import { Row, Col } from 'antd';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { AppWrappperHOC } from '../Root/HOC';
import LandingTrusted from '../NewLanding/Trusted';
import LandingJourney from '../NewLanding/Journey';
import LandingContainer from '../../components/LandingContainer';
import endPoints from '../../config/endPoints';
import { constants } from '../../devUtils';
import { HelmetWrapper, SubTitle } from '../../components';

const LandingPayrollCard = styled.section`
  ${SubTitle}{
    &.stem-height{
      line-height: 28px;
    }
  }
  .bg-gray-gradient{
    background: ${({ theme }) => theme.gradientWebGrayColor};
  }
  .tick-list{
    list-style:none;
    margin: 0px;
    padding: 0px;
    li{
      padding:10px 0px;
      background-image :url(${endPoints.TICK_ICON.URL});
      background-position: left 10px;
      background-size: 25px;
      background-repeat: no-repeat;
      padding-left: 35px;
    }
  }
  .list-grid{
    margin:0px;
    padding:0px;
    list-style:none;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    li{
      width:32%;
      border-radius: 10px;
      @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[1]}) {
        width: 100%;
      };
      &.bg-gray-box{
      background: ${({ theme }) => theme.webGray};
      padding: 20px;
      border-radius: 6px;
      margin-bottom: 20px;
      height: 250px;
      @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
        height: 200px;
        img{
          width: 50%;
        }
      };
      }
      &.bg-white-box{
        background: ${({ theme }) => theme.whiteColor};
        padding: 20px;
        border-radius: 6px;
        margin-bottom: 20px;
        height: 250px;
        @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
        height: 200px;
        img{
          width: 50%;
        }
      };
      }
    }
  }
  .main-table{
    border: 1px solid ${({ theme }) => theme.webGray};
    border-radius: 3px;
    .tr-color{
      background-color: ${({ theme }) => theme.webGray};
      padding: 10px 30px;
    }
    .border-left{
      border-left: 1px solid ${({ theme }) => theme.webGray};
    }
  }
`;

function PayrollCard(props) {
  const { location } = props;
  return (
    <div className="gray-greadient">
      <HelmetWrapper location={location} />
      <LandingPayrollCard>
        <section className="padding-tb-3">
          <LandingContainer>
            <Row type="flex" justify="start" align="middle" gutter={16}>
              <Col xs={24} sm={24} md={11} lg={11} xl={11} className="text-left">
                <h1 className="margin-t-4">
                    Digitising Salaries for the Unbanked
                </h1>
                <p className="margin-t-2 margin-b-3">
                Zaggle Payroll Card is a prepaid card that allows companies to pay Consultants/Contractors/Gig Workers /Temporary Employees/Unbanked Wage Workers as an alternative to direct deposit to bank accounts, cash payments or pay checks.
                  <br /><br />
                  Payroll Card is a re-loadable card with wide acceptance at all merchant outlets supporting Rupay transactions. ATM Cash withdrawals are enabled.
                </p>
                <Link to={constants.LINK_PAYROLL_CARD_CONTACT} className="btn white-btn">Contact us</Link>
              </Col>
              <Col xs={24} sm={24} md={13} lg={13} xl={13} className="text-center">
                <img
                  src={endPoints.PAYROLL_CARD_LANDING_IMAGE.URL}
                  className="width-100"
                  alt={endPoints.PAYROLL_CARD_LANDING_IMAGE.ALT}
                />
              </Col>
            </Row>
          </LandingContainer>
        </section>
        <section className="padding-tb-5">
          <LandingContainer>
            <Row align="top" justify="start" type="flex" gutter={32}>
              <Col xs={24} sm={24} md={11} lg={11} xl={11}>
                <img
                  src={endPoints.PAYROLL_POINTS_IMAGE.URL}
                  alt={endPoints.PAYROLL_POINTS_IMAGE.ALT}
                  className="width-100 margin-t-2"
                />
              </Col>
              <Col xs={24} sm={24} md={13} lg={13} xl={13}>
                <SubTitle fontWeight="800" className="margin-b-1 font-20">Convenient and Safer way to manage Payroll</SubTitle>
                <ul className="tick-list padding-b-2">
                  <li>Payroll Card is a great way to pay unbanked employees</li>
                  <li>Temporary Employees/Consultants/Contractors/Gig Workers Unbanked Wage Workers receive payments on bank holidays and weekend, as card loading is independent of banking hours</li>
                  <li>Dashboard to load cards anytime, anywhere</li>
                  <li>Automate salary payments with “Schedule Payments” feature</li>
                  <li>Card personalisation with employees’ name on it</li>
                  <li>Safer alternative to cash payments, as card can be blocked and reissued if lost</li>
                </ul>
                <Link to={constants.LINK_PAYROLL_CARD_CONTACT} className="btn red-btn">Contact us</Link>
              </Col>
            </Row>
          </LandingContainer>
        </section>
        <section className="padding-tb-5 bg-gray-gradient">
          <LandingContainer>
            <Row align="top" justify="start" type="flex" gutter={[16, 16]}>
              <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-center">
                <SubTitle fontWeight="800" className="padding-b-1 font-24">Features of Zaggle Payroll Card</SubTitle>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <ul className="list-grid">
                  <li className="bg-gray-box">
                    <Row align="top" justify="start" type="flex" gutter={[16, 16]}>
                      <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                        <img
                          src={endPoints.PAYROLL_OUTLINE_ICON.URL}
                          alt={endPoints.PAYROLL_OUTLINE_ICON.ALT}
                          className="width-8"
                        />
                      </Col>
                      <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                        <SubTitle fontWeight="800" className="font-16">Flexibility</SubTitle>
                        <div>Used at a wide range of outlets accepting Rupay Cards. Can be used in online stores also at physical Outlets</div>
                      </Col>
                    </Row>
                  </li>
                  <li className="bg-white-box">
                    <Row align="top" justify="start" type="flex" gutter={[16, 16]}>
                      <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                        <img
                          src={endPoints.PAYROLL_TAP_ICON.URL}
                          alt={endPoints.PAYROLL_TAP_ICON.ALT}
                          className="width-6"
                        />
                      </Col>
                      <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                        <SubTitle fontWeight="800" className="font-16">Convenience</SubTitle>
                        <div>Withdraw money from the ATM outlets.</div>
                      </Col>
                    </Row>
                  </li>
                  <li className="bg-gray-box">
                    <Row align="top" justify="start" type="flex" gutter={[16, 16]}>
                      <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                        <img
                          src={endPoints.PAYROLL_LOCK_ICON.URL}
                          alt={endPoints.PAYROLL_LOCK_ICON.ALT}
                          className="width-8"
                        />
                      </Col>
                      <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                        <SubTitle fontWeight="800" className="font-16">Security</SubTitle>
                        <div>Blocked instantly using the mobile app if lost.</div>
                        <div className="padding-tb-1">POS,ECOM or ATM transactions can be blocked/unblocked using app.</div>
                        <div>Enhanced security with EMV Chip card.</div>
                      </Col>
                    </Row>
                  </li>
                  <li className="bg-white-box">
                    <Row align="top" justify="start" type="flex" gutter={[16, 16]}>
                      <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                        <img
                          src={endPoints.PAYROLL_MAINTENANCE_ICON.URL}
                          alt={endPoints.PAYROLL_MAINTENANCE_ICON.ALT}
                          className="width-8"
                        />
                      </Col>
                      <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                        <SubTitle fontWeight="800" className="font-16 stem-height">Dashboard</SubTitle>
                        <div>Card activation and loading through the dashboard.</div>
                        <div className="padding-tb-1">Schedule payments to cards.</div>
                        <div className="padding-b-1">Block/unblock cards if lost by employee.</div>
                        <div>HRMS attendance integration for salary calculation.</div>
                      </Col>
                    </Row>
                  </li>
                  <li className="bg-gray-box">
                    <Row align="top" justify="start" type="flex" gutter={[16, 16]}>
                      <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                        <img
                          src={endPoints.PAYROLL_SURFACE_ICON.URL}
                          alt={endPoints.PAYROLL_SURFACE_ICON.ALT}
                          className="width-6"
                        />
                      </Col>
                      <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                        <SubTitle fontWeight="800" className="font-16 stem-height">Automated e-KYC process</SubTitle>
                        <div>User completes Aadhaar eKYC using the Mobile/Web App.</div>
                        <div className="padding-tb-1">Automated KYC verification.</div>
                        <div>No physical documentation or manual verification needed.</div>
                      </Col>
                    </Row>
                  </li>
                  <li className="bg-white-box">
                    <Row align="top" justify="start" type="flex" gutter={[16, 16]}>
                      <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                        <img
                          src={endPoints.PAYROLL_FINGERPRINT_SCANNING_ICON.URL}
                          alt={endPoints.PAYROLL_FINGERPRINT_SCANNING_ICON.ALT}
                          className="width-7"
                        />
                      </Col>
                      <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                        <SubTitle fontWeight="800" className="font-16">Zaggle Web/Mobile App</SubTitle>
                        <div>Bharat QR enabled Mobile app payments.</div>
                        <div className="padding-tb-1">Set POS Pin anytime, anywhere.</div>
                        <div className="padding-b-1">Request IPIN.</div>
                        <div> View transactions.</div>
                      </Col>
                    </Row>
                  </li>
                </ul>
              </Col>
            </Row>
          </LandingContainer>
        </section>
        <section className="padding-tb-5">
          <LandingContainer>
            <Row type="flex" justify="start" align="top" className="main-table">
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <SubTitle fontWeight="800" className="tr-color font-18 nomargin">Benefits for Corporate</SubTitle>
                <ul className="tick-list padding-2">
                  <li>Reduced administration cost as card is valid for three years</li>
                  <li>No time spent in writing checks or disbursing cash month on month</li>
                  <li>Dashboard to block/unblock Cards</li>
                  <li>Online Payment & Payment History</li>
                  <li>Dedicated Account Manager</li>
                  <li>Earned wage access (EWA) increases employee satisfaction. Payment is done daily or weekly.</li>
                </ul>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12} className="border-left">
                <SubTitle fontWeight="800" className="tr-color font-18 nomargin">Benefits for Card Holders</SubTitle>
                <ul className="tick-list padding-2">
                  <li>Immediate access to wages - even on Bank holidays/weekends</li>
                  <li>Replace a lost or stolen card</li>
                  <li>Make in-store, online and bill payments</li>
                  <li>Facility to transfer money to Bank Account</li>
                  <li>Transactions history on Mobile or Web App helps in money management</li>
                  <li>SMS alerts for every transaction done on the card</li>
                  <li>No minimum balance needs to be maintained</li>
                </ul>
              </Col>
            </Row>
          </LandingContainer>
        </section>
        <LandingTrusted />
        <LandingJourney />
      </LandingPayrollCard>
    </div>
  );
}

PayrollCard.propTypes = {
  location: shape({}).isRequired,
};

const component = AppWrappperHOC(PayrollCard);

export { PayrollCard };
export default component;



// WEBPACK FOOTER //
// client/containers/PayRollCard/index.jsx